import type { PaymentHistoryItem } from '../api/types';

export const filterCompletedPayments = (items: PaymentHistoryItem[]): PaymentHistoryItem[] =>
  items.filter(item => item.status === 'completed');

export const formatPaymentHistoryDate = (value?: string): string => {
  if (!value) return '-';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '-';
  return date.toISOString().slice(0, 10);
};

export const formatPaymentHistoryAmount = (value?: number): string => {
  if (typeof value !== 'number' || Number.isNaN(value)) return '-';
  return value.toLocaleString('es-CO');
};

export const getPerformerName = (item: PaymentHistoryItem): string => {
  const firstName = typeof item.user?.firstName === 'string' ? item.user.firstName : '';
  const lastName = typeof item.user?.lastName === 'string' ? item.user.lastName : '';
  const fullName = `${firstName} ${lastName}`.trim();
  if (fullName) return fullName;
  if (typeof item.admin?.name === 'string' && item.admin.name.trim()) return item.admin.name.trim();
  return '-';
};

export const buildPageNumbers = (currentPage: number, totalPages: number): number[] => {
  const page = Math.max(1, currentPage);
  const total = Math.max(1, totalPages);

  let start = Math.max(1, page - 2);
  const end = Math.min(total, start + 4);

  if (end - start < 4) {
    start = Math.max(1, end - 4);
  }

  const pages: number[] = [];
  for (let p = start; p <= end; p += 1) {
    pages.push(p);
  }
  return pages;
};
